/**
 * 标准列表按钮相关处理
 */
export default () => ({
  updated() {
    const tableName = this.$router.currentRoute.params.tableName;
    setTimeout(() => {
      switch (tableName) {
        case 'PS_C_PRO_GROUP':
          /* this.PRO_GROUP_getStrategy();
          let dom = null;
          if (this.proGropStrategy === '0') {
            // 手动,沿用老逻辑,隐藏定制
            dom = $('.PROGROUPLISTIMPORT');
            dom[0].style.display = 'none';
          } else if (this.proGropStrategy === '1') {
            // 自动生成,定制,隐藏标准'导入'
            dom = document.getElementById('actionIMPORT');
            if (dom) dom.style.display = 'none';
          } */
          break;
        case 'OC_B_COMPENSATE_ORDER':
          console.log(tableName);
          break;

        default:
          break;
      }
    }, 100);

    // 隐藏标准界面按钮
    const config = new Map([
      ['actionADD', ['PS_C_SKU_PUSH_WMS_MID']], // 新增
      ['actionEXPORT', ['ORDEREXPORTVIEW']], // 导出
    ]);
    [...config.keys()].forEach(action => {
      config.get(action).forEach(i => {
        if (i == tableName) {
          const node = document.getElementById(action);
          if (node) node.style.display = 'none';
        }
      })
    })
  },
  methods: {
    async AddOrganization(v) {
      const row = this.buttons.selectArr[0]
      let obj = {}
      const { webname } = v
      if (webname == "Add_Same_Level_Organization") {
        obj = {
          label: row.P_ID.val,
          id: row.P_ID.refobjid,
        }
      } else {
        obj = {
          label: row.NAME.val,
          id: row.ID.val,
        }
      }
      vm.$store.commit('global/tabOpen', {
        type: 'V',
        url: `/SYSTEM/TABLE_DETAIL/V/CP_C_ORGANIZATION/249232223/New?data=${JSON.stringify(obj)}`,
      });
    },
    async OUTNOTICESITME(v) {
      const { webname } = v
      let tTable = 'SG_B_STO_TRANSFER_OUT_RESULT/249232197/New'
      let type = 'out'
      switch (webname) {
        case "noticesInDetail":
        case "noticesInList":
        case "noticesItemIn":
          tTable = 'SG_B_STO_TRANSFER_IN_RESULT/249232200/New'
          type = 'in'
          break;
        default:
          break;
      }
      // const { tableName, itemId } = vm.$route.params
      const row = this.buttons.selectArr[0]
      await vm.service.common.publicUrlParams('/api/cs/sg/v1/check/transferCheck ', {
        id: row.ID.val,
        type
      }).then(res => {
        if (res.data.code == 0) {
          const defaultVal = {}
          const defaultLabel = {}
          for (const key in row) {
            const item = this.ag.datas.tabth.find(x => x.colname === key)
            if (item) {
              defaultVal[key] = row[key].val
              defaultLabel[key] = row[key].val
              if (item.display == 'select') {
                defaultVal[key] = item.combobox.find(y => y.limitdesc == row[key].val).limitval
                defaultLabel[key] = row[key].val
              }
              if (row[key].refobjid) {
                defaultVal[key] = row[key].refobjid
                defaultLabel[key] = row[key].val
              }
            }
          }
          const obj = {
            id: row.ID.val,
            defaultVal,
            defaultLabel
          }
          vm.$store.commit('global/tabOpen', {
            type: 'V',
            url: `/SYSTEM/TABLE_DETAIL/V/${tTable}?data=${JSON.stringify(obj)}`,
          });
        }
      })
    },
    async BACK_TO_SG_B_PHY_INVENTORY() {
      // 库存中心/店务管理/盈亏单 -> 返回盘点录入单
      vm.$store.commit('global/tabOpen', {
        type: 'S',
        url: `/SYSTEM/TABLE/SG_B_PHY_INVENTORY/249230940`,
      });
    },
    async BACK_TO_SG_B_SEND_ORDER() {
      // 在pos里，[全渠道发货单]到[拣货单]后就无法返回[全渠道发货单]了，特此加按钮处理
      vm.$store.commit('global/tabOpen', {
        type: 'C',
        url: `/CUSTOMIZED/SG_B_SEND_ORDER/41461069`,
      });
    },
    async generateTransferOrder() {
      const data = this.$store.state[R3.getModuleName()]
      const ids = data.buttons.selectIdArr
      await this.service.common.publicUrlParams('/api/cs/vip/vipComReturnPo/validateGenerateTransferOrder', {id: ids[0]}).then(res => {
        if (res.data.code == 0) {
          /*
          通过后，跳转到逻辑调拨单新增页面，
          "(SG_B_STO_TRANSFER.ID+10)":
              发货仓(SENDER_STORE_ID)默认填充唯品会退货单的收货逻辑仓，
          "(SG_B_STO_TRANSFER.ID+90)":
              来源单据类型(SOURCE_BILL_TYPE)默认填充为唯品会退货单(400)，来源单据编号(SOURCE_BILL_NO)默认填充唯品会退货单的单据编号(BILL_NO)
           */
          const row = data.buttons.selectArr[0]
          const { CP_C_DEST_ID: {refobjid, val}, BILL_NO } = row
          vm.$store.commit('global/tabOpen', {
            type: 'V',
            url: `/SYSTEM/TABLE_DETAIL/V/SG_B_STO_TRANSFER/249230788/New?SENDER_STORE_ID=${refobjid},${val.replace('&','_j_')}&SOURCE_BILL_NO=${BILL_NO.val}`,
          });
        }
      })
    },
    async MQ_PUBLISH() {
      await this.service.systemConfig.mqEnableAll({}).then(res => {
        if (res.data.code == 0) {
          this.$Message.success(res.data.message);
          $('.R3-buttonList #refresh')[0].click()
        }
      })
    },
    async actionBeforeHandle(btn) {
      const data = this.$store.state[R3.getModuleName()]
      let query = null
      const select = data.buttons.selectIdArr
      await this.$refs.R3listform.getFormData().then(res => {
        query = res
      })
      if (btn.webname == "exportConsignmentStorage") {
        const SELECT_DATE = this.$refs.R3listform.$children[0].$children[0].$children[0].$children[0].valuedata
        SELECT_DATE != '' && (query.SELECT_DATE = SELECT_DATE)
      }
      return {
        webname: btn.webname,
        query,
        selectRows: data.buttons.selectArr,
        select,
        arr_ids: select,
        str_ids: select.join()
      }
    },
    async AC_F_COMM_CUSTOM_ACTION(btn) {
      const btn_api = {
        "AC_F_SOURCE_REFUND_EXPORT": 'acFSourceRefundExport', // 对账来源退款-导出
        "AC_F_SOURCE_RETURN_EXPORT": 'acFSourceReturnExport', // 对账来源退单-导出
        "AC_F_SOURCE_ORDER_EXPORT": 'acFSourceOrderExport', // 对账来源订单-导出
        "AC_F_SETTLE_BIL_CANCEL": 'cancelSettleBill', // 对账结算单-取消结算
        "AC_F_CONFIRM_BILL_MANUAL_SETTLE": 'manualSettle', // 对账单-手动结算
        "AC_F_CONFIRM_BILL_RECONFIRM": 'reBill', // 对账单-重新对账
        "AC_F_SETTLE_BIL_DEL": 'delSettleBill' // 结算单-删除
      }
      // /api/cs/sg/consignmentStorage/export
      const { query, arr_ids, webname } = await this.actionBeforeHandle(btn)
      if (!Object.keys(query).length && arr_ids.length < 1) {
        $fcError('请填写筛选条件或勾选要操作的数据！')
        return
      }
      const param = {
        TABLE: this.$router.currentRoute.params.tableName,
        IDS: arr_ids,
        CONDITION: query,
        BUSINESS: {}
      }
      $fcWarn({
        className: 'ark-dialog',
        title: $it('mT.tips'), // 提示
        content: `是否确定该操作？`,
        mask: true,
        showCancel: true,
        onOk: () => {
          this.service.financeCenter[btn_api[webname]](param).then(res => {
            if (res.data.code == 0) {
              switch (webname) {
                case 'AC_F_SETTLE_BIL_CANCEL':
                  $fcWarn({
                    title: $it('mT.tips'), // 提示
                    content: res.data.message
                  });
                  break;
                case 'AC_F_SOURCE_ORDER_EXPORT':
                case 'AC_F_SOURCE_RETURN_EXPORT':
                case 'AC_F_SOURCE_REFUND_EXPORT':
                  this.myHook.asyncTask.call() // 唤出异步任务列表
                  break;
                default:
                  this.$Message.success(res.data.message)
                  break;
              }
              const arr = ['exportConsignmentStorage', 'AC_F_SOURCE_ORDER_EXPORT', 'AC_F_SOURCE_RETURN_EXPORT', 'AC_F_SOURCE_REFUND_EXPORT']
              if (!arr.includes(webname)) { // 导出不需要刷新页面
                $('.R3-buttonList #refresh')[0].click()
              }
            }
          });
        }
      });
    },
    async EXPORT_CONSIGNMENT_STORAGE(btn) {
      const btn_api = {
        "RPT_GOODS_MARKET_STATISTICS_REPORT": 'goodsMarketStatisticsExport', // 商品销售统计报表-导出
        "exportConsignmentStorage": 'consignmentStorageExport', // OMS与SAP寄售库存核对-导出
        "RPT_NOTSENT_PRESALE_ORDER_TRANSFER_ITEM_EXPORT": 'saleOrderNoSendTransferItemExport', // 预售订单未发调拨明细-导出
        "STORE_DISTRIBUTION_EXPORT": 'storeDistributionExport', // 门店配货到货率查询-导出
      }
      const { query, webname, selectRows } = await this.actionBeforeHandle(btn)
      const searchdata = {
        table: this.$router.currentRoute.params.tableName,
        startindex: 0,
        fixedcolumns: query,
        column_include_uicontroller: true,
        isolr: false
      }
      if (webname == 'STORE_DISTRIBUTION_EXPORT') {
        searchdata.selectRows = selectRows
      }
      const param = new FormData();
      param.append('searchdata', JSON.stringify(searchdata));

      $fcWarn({
        className: 'ark-dialog',
        title: $it('mT.tips'), // 提示
        content: `是否确定该操作？`,
        mask: true,
        showCancel: true,
        onOk: () => {
          $utils.mainContentLoading(true)
          this.service.financeCenter[btn_api[webname]](param).then(res => {
            if (res.data.code == 0) {
              switch (webname) {
                case 'exportConsignmentStorage':
                  window.location = `/p/cs/download?filename=${res.data.data}`
                  break;
                case 'RPT_NOTSENT_PRESALE_ORDER_TRANSFER_ITEM_EXPORT':
                case 'STORE_DISTRIBUTION_EXPORT':
                case 'RPT_GOODS_MARKET_STATISTICS_REPORT':
                  this.myHook.asyncTask.call() // 唤出异步任务列表
                  break;
                default:
                  this.$Message.success(res.data.message)
                  break;
              }
              const arr = ['exportConsignmentStorage', 'RPT_NOTSENT_PRESALE_ORDER_TRANSFER_ITEM_EXPORT', 'STORE_DISTRIBUTION_EXPORT', 'RPT_GOODS_MARKET_STATISTICS_REPORT']
              if (!arr.includes(webname)) { // 导出不需要刷新页面
                $('.R3-buttonList #refresh')[0].click()
              }
            }
          }).finally(() => {
            $utils.mainContentLoading()
          }) ;
        }
      });
    },
    SgBWmsToInventoryChangeNoticeCmd() {
      const data = this.$store.state[R3.getModuleName()]
      const select = data.buttons.selectIdArr
      if (select.length < 1) {
        $fcError('请先勾选要操作的数据！')
        return
      }
      $fcWarn({
        className: 'ark-dialog',
        title: $it('mT.tips'), // 提示
        content: `是否确定转化？`,
        mask: true,
        showCancel: true,
        onOk: () => {
          const param = new FormData();
          param.append('ids', select.join())
          this.service.inventoryCenter.updateByWmsBillNo(param).then(res => {
            if (res.data.data.code == 0) {
              this.$Message.success(res.data.data.message)
              $('.R3-buttonList #refresh')[0].click()
            } else {
              $fcError(res.data.data.message)
            }
          });
        }
      });
    },
    async BACK_MODIFY(btn) {
      // 商品效期策略 - 反审核并修改
      const { query, str_ids } = await this.actionBeforeHandle(btn)
      if (!str_ids) {
        $fcError('请勾选要操作的数据！')
        return
      }
      $fcWarn({
        className: 'ark-dialog',
        title: $it('mT.tips'), // 提示
        content: `是否确定对该订单进行【反审核并修改】操作？`,
        mask: true,
        showCancel: true,
        onOk: () => {
          this.service.strategyPlatform.backAndModify({ objid: str_ids }).then(res => {
            if (res.data.code == 0) {
              $utils.tabCloseAppoint(this);
              this.$destroy(true);
              this.$store.commit("global/tabOpen", {
                  id: str_ids,
                  type: "V",
                  tableName: "ST_C_EXPIRY_DATE",
                  tableId: '249231388',
              });
            }
          });
        }
      });

    },
    async BILL_DELETE(obj) {
      // 通用/支付宝/拼多多/抖音原始账单、平台账单表、对账单 - 删除
      const { query, select } = await this.actionBeforeHandle(obj)
      if (!Object.keys(query).length && select.length < 1) {
        $fcError('请填写筛选条件或勾选要操作的数据！')
        return
      }
      const param = {
        table: this.$router.currentRoute.params.tableName,
        del_type: select.length ? 'by_ids' : 'by_condition',
        ids: select.join(),
        condition: query
      }
      $fcWarn({
        className: 'ark-dialog',
        title: $it('mT.tips'), // 提示
        content: `是否确定删除要操作的账单？`,
        mask: true,
        showCancel: true,
        onOk: () => {
          this.service.financeCenter.delCfmBill(param).then(res => {
            if (res.data.code == 0) {
              this.$Message.success(res.data.message)
              // $('#AC_F_COMMON_ORIGINAL_BILL #refresh').trigger('click')
              $('.R3-buttonList #refresh')[0].click()
            }
          });
        }
      });
    },
    // 组合商品-查询商品编码生成策略
    PRO_GROUP_getStrategy: _.throttle(
      function () {
        const formData = new FormData();
        formData.append('param', 'ps_c_pro_group');
        formData.append('type', '组合商品列表');
        this.service.commodityCenter.getCodeAndParam(formData).then((res) => {
          const data = res.data;
          if (data.code === 0) {
            const {
              ps_c_pro_group_sku_code_rule: tempRule, // 决定导入的模板
            } = data.data;
            this.proGropStrategy = tempRule;
          } else {
            this.$Message.warning(data.message);
          }
        });
      },
      3000,
      { trailing: false }
    ),
    async "CUSTOMIZED/VIPCOM_DISTRIBUTION_COPY"() {
      const _id = this.$store.state[R3.getModuleName()].buttons.selectIdArr[0]
      const param = {
        "originalId": _id
      }
      const params = new FormData()
      params.append('param', JSON.stringify(param))
      this.service.orderCenter.checkCopyDistribution(param).then(res => {
        const goTo = function () {
          vm.$store.commit("global/tabOpen", {
            type: "V",
            url: `/SYSTEM/TABLE_DETAIL/V/OC_B_VIPCOM_DISTRIBUTION/24733/${_id}?ISCOPY=Y&OID=${_id}`,
          });
        }
        if (res.data.code == 2) {
          $fcWarn({
            className: 'ark-dialog',
            title: $it('mT.tips'), // 提示
            content: `${res.data.message}`,
            mask: true,
            showCancel: true,
            onOk: () => {
              goTo()
            }
          });
        } else if (res.data.code == 0) {
          goTo()
        }
      });
    }
  },
});
